export default "__VITE_ASSET__DnNE$JjS__"